import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=05fd2466&scoped=true"
var script = {}
import style0 from "./IconDownload.vue?vue&type=style&index=0&id=05fd2466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd2466",
  null
  
)

export default component.exports